import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import styles from '../../styles/main.scss';
import '../../styles/info-pages/info-pages.scss';
import HeaderAuth from '../includes/HeaderAuth';
import TermsAndConditions from './TermsAndConditions';
import PrivacyPolicy from './PrivacyPolicy';
import ContactUs from './ContactUs';
import FaqPage from './FaqPage';
import About from './About';
import { connect } from 'react-redux';
import { addCriteria } from 'Actions/criteriaActions';

function TabContainer(props) {
  return <Typography component="div">{props.children}</Typography>;
}

class InfoPages extends React.Component {
  state = {
    value: 0,
  };

  // TODO: use component did mount and test
  UNSAFE_componentWillMount() {
    const { pathname } = this.props.location;
    this.switchTab(pathname);
  }

  // TODO: use component did update and test
  UNSAFE_componentWillUpdate(nextProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.switchTab(nextProps.location.pathname);
    }
  }

  switchTab = pathname => {
    let value = 0;
    switch (pathname) {
      case '/about':
        value = 0;
        break;
      case '/terms-and-conditions':
        value = 1;
        break;
      case '/privacy-policy':
        value = 2;
        break;
      case '/faq':
        value = 3;
        break;
      case '/contact':
        value = 4;
        break;
      default:
        value = 0;
    }
    this.setState({ value });
  };

  handleChange = (event, value) => {
    switch (value) {
      case 0:
        this.props.history.push('/about');
        break;
      case 1:
        this.props.history.push('/terms-and-conditions');
        break;
      case 2:
        this.props.history.push('/privacy-policy');
        break;
      case 3:
        this.props.history.push('/faq');
        break;
      case 4:
        this.props.history.push('/contact');
        break;
      default:
        this.props.history.push('/');
    }
    this.setState({ value });
  };

  render() {
    const { value } = this.state;
    return (
      <div className="">
        <HeaderAuth colored type="/login" />
        <AppBar
          classes={{
            root: 'e-pos-r',
          }}
          color={'secondary'}
        >
          <Tabs
            value={value}
            onChange={this.handleChange}
            indicatorColor={'primary'}
            centered
            classes={{ flexContainer: 'infoPagesTabs' }}
          >
            <Tab label="About" />
            <Tab label="Terms & Conditions" />
            <Tab label="Privacy policy" />
            <Tab label="FAQ" />
            <Tab label="Contact us" />
          </Tabs>
        </AppBar>
        {value === 0 && (
          <TabContainer>
            <About />
          </TabContainer>
        )}
        {value === 1 && (
          <TabContainer>
            <TermsAndConditions />
          </TabContainer>
        )}
        {value === 2 && (
          <TabContainer>
            <PrivacyPolicy />
          </TabContainer>
        )}
        {value === 3 && (
          <TabContainer>
            <FaqPage />
          </TabContainer>
        )}
        {value === 4 && (
          <TabContainer>
            <ContactUs />
          </TabContainer>
        )}
      </div>
    );
  }
}

const mapStateToProps = store => {
  return {
    user: store.user.user,
  };
};

export default connect(mapStateToProps, null)(InfoPages);
